import React from 'react';
import { CheckCircle, AlertTriangle, XCircle, Calendar } from 'lucide-react';

export default function AttendanceStats({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-green-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Hadir</p>
            <p className="text-2xl font-bold text-green-600">{stats.present}</p>
          </div>
          <CheckCircle className="w-8 h-8 text-green-500" />
        </div>
      </div>
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-amber-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Terlambat</p>
            <p className="text-2xl font-bold text-amber-600">{stats.late}</p>
          </div>
          <AlertTriangle className="w-8 h-8 text-amber-500" />
        </div>
      </div>
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-red-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Tidak Hadir</p>
            <p className="text-2xl font-bold text-red-600">{stats.absent}</p>
          </div>
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
      </div>
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-blue-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Cuti/Izin</p>
            <p className="text-2xl font-bold text-blue-600">{stats.leave}</p>
          </div>
          <Calendar className="w-8 h-8 text-blue-500" />
        </div>
      </div>
    </div>
  );
}
